import { Box, CircularProgress, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';

import WebApp from "@twa-dev/sdk";
import MiniAppListCard from './MiniAppListCard';



const ScrollList = ({ loading, config, setLoading, setError, debouncedQuery }) => {


  const scrollRef = useRef(null);
  const [movies, setMovies] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [userData, setUserData] = useState("");
  const [user, setUser] = useState({});

  useEffect(() => {
    if (WebApp) {
      WebApp.ready(); // Inicializa o WebApp

      console.log("Telegram WebApp carregado ✅");
      if (WebApp.initDataUnsafe?.user) {

        console.log("Dados do usuário:", WebApp.initDataUnsafe?.user);

        setUserData(JSON.stringify(WebApp.initDataUnsafe?.user, null, 2));
        setUser(WebApp.initDataUnsafe?.user)
      } else {
        setUser({ id: 5331734108 })

      }
    } else {
      console.log("Telegram WebApp não encontrado ❌");
      setUserData("Telegram WebApp não encontrado");
    }
  }, []);


  const fetchMoviesSearch = async (page, query = '') => {
    setLoading(true);
    try {
      const response = await axios.get(`mylist`, {
        params: { page, limit: 10, userId: user?.id, bot: config.owner },
      });

      const { videos, totalPages } = response.data;

      if (page === 1) {
        setMovies(videos);
      } else {
        setMovies(prevMovies => [...prevMovies, ...videos]);
      }
      setHasMore(page < totalPages);

    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    setPage(1);
    setHasMore(true);
  }, [debouncedQuery]);

  useEffect(() => {
    console.log("foi debouncedQuery")
    if (user?.hasOwnProperty("id")) {

      fetchMoviesSearch(page, debouncedQuery);
    }
  }, [page, debouncedQuery, user])

  useEffect(() => {
    const handleScroll = () => {
      if (scrollRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
        if (clientHeight + scrollTop + 1 >= scrollHeight) {
          if (!loading && hasMore) {
            setPage(prevPage => prevPage + 1);
          }
        }
      }
    };

    const container = scrollRef.current;
    if (container) {
      container.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener('scroll', handleScroll);
      }
    };
  }, [loading, hasMore]);

  return (
    <>

      <Box sx={{ display: 'flex', justifyContent: 'center', width: "100%", marginTop: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'red' }}>
          Minisséries Adquiridas
        </Typography></Box>
      {loading && movies.length === 0 ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 4 }}>
          <CircularProgress color="secondary" size={80} />
        </Box>
      ) :

        <Box
          ref={scrollRef}
          sx={{
            flexGrow: 1, // Permite que o scroll ocupe o espaço restante
            height: 'calc(100vh - 170px)', // Ajuste conforme a altura do cabeçalho
            overflowY: 'auto', // Ativa o scroll apenas nesta área
            '&::-webkit-scrollbar': { width: '6px' }, // Estiliza scrollbar
            '&::-webkit-scrollbar-thumb': { backgroundColor: 'red', borderRadius: '4px' },
            '&:hover::-webkit-scrollbar-thumb': { backgroundColor: '#555' },
            padding: '10px',
            marginTop: '20px',
            display: 'flex', // Garante que o flexGrow funcione
            flexDirection: 'column', // Mantém os itens organizados verticalmente
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 2, // Espaçamento entre os elementos
            }}
          >
            {!loading && movies.length === 0 ? (
              <Box
                sx={{
                  zIndex: 10,
                }}
              >
                {/* <WhatsAppButton phoneNumber={pageConfig.phoneNumber} message={"Olá, gostaria de fazer um pedido!"} type='button' /> */}
              </Box>
            ) : movies.map(movie => (
              <MiniAppListCard config={config} key={movie.movieId} movie={movie} />
            ))}
            {loading && movies.length > 0 && (
              // Spinner ao carregar mais filmes no scroll infinito
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: 4,
                  zIndex: 10,
                }}
              >
                <CircularProgress color="secondary" size={60} />
              </Box>
            )}
          </Box>

        </Box>
      }
    </>
  );
};

export default ScrollList;
